import * as THREE from 'three';
import { CSS2DRenderer } from 'three/examples/jsm/renderers/CSS2DRenderer';
import { CSS3DRenderer } from 'three/examples/jsm/renderers/CSS3DRenderer';
import { browserName } from 'react-device-detect';

export const getRenderer = (type) => {
	const rendererKey = `${type}_renderer`;
	const ret =
		window[rendererKey] ||
		new THREE.WebGLRenderer({
			antialias: true,
			preserveDrawingBuffer: true,
			alpha: true, //type === 'zoom', TODO: can this just always be true
			logarithmicDepthBuffer: true,
		});
	window[rendererKey] = ret;
	return ret;
};

export const initThreeJSScene = ({
	canvasRef,
	cameraRef,
	scene,
	css2DRendererRef,
	css3DRendererRef,
	isRT3D,
}) => {
	const canvas = canvasRef.current;
	const clock = new THREE.Clock();
	clock.start();

	setupCSS2DRenderer(css2DRendererRef.current, canvas);
	setupCSS3DRenderer(css3DRendererRef.current, canvas, isRT3D);

	scene.add(cameraRef.current);
};

export const setupXR = (renderer) => {
	// Enable XR and other features
	renderer.setPixelRatio(window.devicePixelRatio);
	renderer.setSize(window.innerWidth, window.innerHeight);
	renderer.localClippingEnabled = true;
	if (browserName === 'Oculus Browser')
		renderer.xr.setFramebufferScaleFactor(2);
	renderer.xr.setReferenceSpaceType('local-floor');
	renderer.physicallyCorrectLights = true;
	renderer.xr.enabled = true;
};

export const setupCamera = (camera) => {
	const posX = 0.1;
	const rotY = (90 * Math.PI) / 180;

	camera.position.set(posX, 0, 0);
	camera.rotation.set(0, rotY, 0);
	camera.lookAt(0, 0, 0);
	camera.updateProjectionMatrix();
};

export const setupCSS2DRenderer = (css2DRenderer, canvas) => {
	css2DRenderer.domElement.style.position = 'absolute';
	css2DRenderer.domElement.style.top = '0px';
	css2DRenderer.domElement.style.zIndex = 0;
	css2DRenderer.domElement.style.pointerEvents = 'none';
	canvas.appendChild(css2DRenderer.domElement);
};

export const createCSS2DRenderer = (type) => {
	const rendererKey = `${type}_css2DRenderer`;
	const ret = window.css2DRenderer || new CSS2DRenderer();
	window[rendererKey] = ret;
	return ret;
};

export const setupCSS3DRenderer = (css3DRenderer, canvas, isRT3D) => {
	const css3DParent = document.createElement('div');
	css3DParent.style.position = 'absolute';
	css3DParent.style.top = '0px';
	css3DParent.style.left = '0px';
	css3DParent.style.width = '100%';
	css3DParent.style.height = '100%';
	css3DParent.style.zIndex = isRT3D ? 0 : 1;
	css3DParent.style.pointerEvents = 'none';
	css3DParent.id = 'div_css3DParent';
	canvas.parentNode.insertBefore(css3DParent, canvas);
	css3DRenderer.domElement.style.position = 'absolute';
	css3DRenderer.domElement.style.top = '0px';
	css3DRenderer.domElement.style.zIndex = 0;
	css3DRenderer.domElement.style.pointerEvents = 'none';
	css3DRenderer.domElement.id = 'div_css3DRenderer';
	css3DParent.appendChild(css3DRenderer.domElement);
};

export const createCSS3DRenderer = (type) => {
	const rendererKey = `${type}_css3DRenderer`;
	const ret = window.css3DRenderer || new CSS3DRenderer();
	window[rendererKey] = ret;
	return ret;
};
